import { SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  PageHeader,
  Row,
  Select,
  Space,
  Spin,
  Statistic,
  Table,
  Tag
} from "antd";
import { Component } from "react";
import { CSVLink } from "react-csv";
import Highlighter from "react-highlight-words";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { DELETE, GET, UPDATE } from "../constants/request-type";
import { delete_order } from "../constants/routes";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";
import { openNotificationWithIcon } from "../functions/notification";

import { todayDate } from "../functions/dateFunctions";

import logger from "../../utils/logger.js";
const token = sessionStorage.getItem("auth_token");

const { RangePicker } = DatePicker;

const { Option } = Select;

class Order extends Component {
  state = {
    selectedRowKeys: [],
    searchText: "",
    searchedColumn: "",
    load: true,
    data: [],
    list: [],
    chef: [],
    chef_selected: null,
    selected_date: todayDate(),
    start: null,
    end: null,
    selected: true,
    overall: true,
    allowed: false,
    blocked: false,
    driver_around: [],
    openModal: false,
    ride_selected: null,
    show: "all",
    rate: null,
    rate_view: false
  };

  componentDidMount() {
    this.getData();
  }

  static defaultProps = {
    center: {
      lat: 43.65107,
      lng: -79.347015
    },
    zoom: 5
  };

  getData = async () => {
    const request_details = {
      type: GET,
      url: service_api,
      route: "order-glocery/get-all",
      data: null,
      token: token
    };

    const request_details_partner = {
      type: GET,
      url: service_api,
      route: "glocery-partner/get-all",
      data: null,
      token: token
    };

    try {
      const response = await MakeRequestAsync(request_details);
      const response_chef = await MakeRequestAsync(request_details_partner);

      this.setState({
        load: false,
        chef: decryptSingleData(response_chef?.data?.glocery_partner),
        data: decryptSingleData(response.data.order)
      });
    } catch (err) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    }
  };

  handleStatus = async (id, status) => {
    const data = {
      status: status
    };
    const request_details = {
      type: UPDATE,
      url: service_api,
      route: "order-glocery" + "/" + "update-order-admin" + "/" + id,
      data: data,
      token: token
    };

    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon("error", `${err.response.data}`);
    }
  };

  onSelectChange = (selectedRowKeys) => {
    logger.log("selectedRowKeys changed: ", selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      )
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handleDelete = async (id) => {
    const request_details = {
      type: DELETE,
      url: service_api,
      route: "order-glocery" + "/" + delete_order + "/" + id,
      token: token
    };
    try {
      await MakeRequestAsync(request_details);
    } catch (err) {
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    }

    return setTimeout(() => window.location.reload(), 1000);
  };

  render() {
    const columns = [
      {
        title: "Id",
        dataIndex: "_id",

        ...this.getColumnSearchProps("_id")
      },
      {
        title: "Facturation",
        dataIndex: "billing_details",
        render: (text) => (
          <Tag color={"purple"}>
            <span>
              Montant total: <b>{"$" + text?.amount?.toFixed(2)}</b>
            </span>
            <br />
            <span>
              Gain glocery: <b>{"$" + text?.earned_glocery?.toFixed(2)}</b>
            </span>
            <br />
            <span>
              Gain pani: <b>{"$" + text?.earned_pani?.toFixed(2)}</b>
            </span>
            <br />
            <span>
              Gain livreur: <b>{"$" + text?.delivery_price?.toFixed(2)}</b>
            </span>
            <br />
            <span>
              Date de commande: <b>{"$" + text?.delivery_date}</b>
            </span>
          </Tag>
        )
      },
      {
        title: "Payé",
        dataIndex: "paid",
        render: (text) => (
          <Tag color={text === true ? "green" : "volcano"}>
            {text === true ? "Oui" : "Non"}
          </Tag>
        )
      },
      {
        title: "Articles",
        dataIndex: "food",
        render: (text) =>
          text?.map((item) => (
            <>
              <Tag color={"purple"}>
                <a href={item?.pic} target="_blank">
                  <img
                    src={item?.pic}
                    style={{
                      width: 50,
                      height: 50,
                      objectFit: "contain"
                    }}
                    alt={"food-logo"}
                  />
                </a>
                <br />
                <span>
                  <b>{item?.name}</b>
                </span>
                <br />
                <span>
                  Qty:<b>{item?.qty}</b>
                </span>
                <br />
                <span>
                  Coût: <b>${item?.cost * item?.qty}</b>
                </span>
              </Tag>
            </>
          ))
      },
      {
        title: "Chef",
        dataIndex: "chef_id",
        render: (text) => (
          <Tag color={"purple"}>
            <span>{text?.firstname + " " + text?.lastname}</span>
            <br />
            <span>{text?.email}</span>
            <br />
            <span>{text?.number}</span>
          </Tag>
        )
      },
      {
        title: "Livreur",
        dataIndex: "deliverman_id",
        render: (text) =>
          text === null ? (
            "Aucun Livreur"
          ) : (
            <Tag color={"purple"}>
              <img
                src={text?.pic}
                style={{
                  width: 60,
                  height: 60,
                  objectFit: "contain"
                }}
                alt={"deliverman-logo"}
              />
              <br />
              <span>{text?.firstname + " " + text?.lastname}</span>
              <br />
              <span>{text?.email}</span>
              <br />
              <span>{text?.number}</span>
            </Tag>
          )
      },
      {
        title: "Note Livreur",
        dataIndex: "rate_driver",
        render: (text) =>
          text?.rate === null ? (
            "Aucun"
          ) : (
            <Tag color={"purple"}>
              <span>{text?.text}</span>
              <br />
              <span>{text?.rate} étoiles</span>
            </Tag>
          )
      },
      {
        title: "Status",
        dataIndex: "status",
        render: (text) => (
          <Tag
            color={
              text === 0
                ? "orange"
                : text === 1
                  ? "green"
                  : text === 2
                    ? "yellow"
                    : text === 3
                      ? "purple"
                      : text === 4
                        ? "volcano"
                        : "blue"
            }
          >
            <b>
              {text === 0 && "En attente"}
              {text === 1 && "Accepter"}
              {text === 2 && "En chemin"}
              {text === 3 && "Livrer"}
              {text === 4 && "Annuler"}
              {text === 5 && "Rembourser"}
            </b>
          </Tag>
        )
      },
      {
        title: "Date et temps",
        dataIndex: "createdAt",
        render: (text) => <Tag>{text?.slice(0, 16)}</Tag>
      },
      {
        title: "Actions",
        fixed: "right",
        render: (text, record) => (
          <div>
            <Dropdown
              overlay={MenuButton(record)}
              placement="bottomCenter"
              arrow
            >
              <Button>Options</Button>
            </Dropdown>
          </div>
        )
      }
    ];

    const MenuButton = (record) => (
      <Menu>
        <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 0)}>
            En attente
          </Link>
        </Menu.Item>

        <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 1)}>Accepter</Link>
        </Menu.Item>

        <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 2)}>
            En chemin
          </Link>
        </Menu.Item>

        <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 3)}>Livrer</Link>
        </Menu.Item>

        <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 4)}>Annuler</Link>
        </Menu.Item>

        <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 5)}>
            Rembourser
          </Link>
        </Menu.Item>

        <Menu.Item>
          <Link onClick={() => this.handleDelete(record._id)}>Supprimer</Link>
        </Menu.Item>
      </Menu>
    );

    const { load, data, start, end, chef, chef_selected, selected_date } =
      this.state;
    return (
      <>
        <PageHeader
          title="Commandes"
          tags={<Tag color="blue">Liste des commandes</Tag>}
          subTitle=""
          extra={[
            this.props.status < 2 && (
              <Button
                style={{
                  marginLeft: 10
                }}
                type={"danger"}
                onClick={() => {}}
              >
                Rechercher des livreurs
              </Button>
            ),
            <RangePicker
              showTime
              onChange={(data) => {
                logger.log(data);
                if (data === null) {
                  this.setState({
                    start: null,
                    end: null
                  });
                }
                let d1 = data[0].format("YYYY-MM-DDTHH:mm:ss");
                let d2 = data[1].format("YYYY-MM-DDTHH:mm:ss");

                this.setState({ start: d1, end: d2 });
              }}
            />,
            <CSVLink data={data}>Exporter CSV/Excel</CSVLink>
          ]}
        >
          <Row>
            <Statistic
              title="Total"
              value={
                data?.filter((item) => {
                  if (start === null && end === null) {
                    return (
                      item?.glocery_id?._id === chef_selected &&
                      item?.billing_details?.delivery_date === selected_date
                    );
                  }
                  return (
                    item?.glocery_id?._id === chef_selected &&
                    item.createdAt >= start &&
                    item.createdAt <= end &&
                    item?.billing_details?.delivery_date === selected_date
                  );
                })?.length
              }
            />
          </Row>

          <Row gutter={16}>
            {!load && (
              <>
                <Col span={4}>
                  <Form.Item
                    label="Selectionner un partenaire"
                    rules={[
                      {
                        required: true,
                        role: "selectionner un partenaire"
                      }
                    ]}
                  >
                    <Select
                      allowClear
                      style={{ width: "100%" }}
                      placeholder="Selectionner un partenaire"
                      defaultValue={chef_selected}
                      onChange={(data) => {
                        return this.setState({ chef_selected: data });
                      }}
                    >
                      {chef?.map((item) => (
                        <Option key={item?._id}>
                          <span>{item?.company_name}</span>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item
                    label="Selectionner un date"
                    rules={[
                      {
                        required: true,
                        role: "selectionner une date"
                      }
                    ]}
                  >
                    <input
                      name="selected_date"
                      type="date"
                      value={selected_date}
                      style={{
                        height: "33px",
                        border: "1px solid #e9e9e9",
                        backgroundColor: "#ffffff",
                        padding: 5
                      }}
                      onChange={(e) => {
                        this.setState({
                          selected_date: e.target.value
                        });
                      }}
                    />
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>
          <Row
            style={{
              marginTop: 20
            }}
          >
            {load ? (
              <Space size="middle">
                <Spin size="large" />
              </Space>
            ) : (
              <Col span={24}>
                <Table
                  scroll={{
                    x: "auto"
                  }}
                  columns={columns}
                  dataSource={data?.filter((item) => {
                    if (start === null && end === null) {
                      return (
                        item?.glocery_id?._id === chef_selected &&
                        item?.billing_details?.delivery_date === selected_date
                      );
                    }
                    return (
                      item?.glocery_id?._id === chef_selected &&
                      item.createdAt >= start &&
                      item.createdAt <= end &&
                      item?.billing_details?.delivery_date === selected_date
                    );
                  })}
                />
              </Col>
            )}
          </Row>
        </PageHeader>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    admin: state.admin
  };
};

const mapDispatchStoreToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchStoreToProps)(Order);
